import { MenuItem } from '@mui/material'
import { ActionsItemProps } from './actions'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import { useFutureDeliveryModalStore } from 'modules/orders/components/futureDeliveryModal/useFutureDeliveryModalStore'

export const FutureDelivery = ({ order, disabled }: ActionsItemProps) => {
  const setModalOpen = useFutureDeliveryModalStore.useSetModalOpen()
  const setOrderId = useFutureDeliveryModalStore.useSetOrderId()

  return (
    <MenuItem
      onClick={() => {
        setOrderId(order.orderId)
        setModalOpen(true)
      }}
      sx={{
        fontSize: 16
      }}
      disabled={disabled}
    >
      <LocalShippingIcon sx={{ margin: '8px 15px 0 0' }} />
      <span style={{ margin: '8px 15px 0 0' }}>Entrega Futura</span>
    </MenuItem>
  )
}
